import { AxiosError } from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { RisksResponse } from './RisksTypes';
import { ErrorResponse } from 'store/ReduxTypes';
import { api } from '@utils/api';

/* ---------- POST /api/v1/risks-requests?instance_id=… ---------- */
export const requestRiskCalculation = createAsyncThunk<
  RisksResponse,
  number, // instanceId
  { rejectValue: ErrorResponse }
>('risks/request', async (instanceId, { rejectWithValue }) => {
  try {
    const { data } = await api.post<RisksResponse>(
      '/risks-requests',
      {}, // тело пустое
      { params: { instance_id: instanceId } },
    );
    return data; // status = pending
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});

/* ---------- GET /api/v1/risks-requests/{requestId} ---------- */
export const getRiskStatus = createAsyncThunk<
  RisksResponse,
  number,
  { rejectValue: ErrorResponse }
>('risks/status', async (requestId, { rejectWithValue }) => {
  try {
    const { data } = await api.get<RisksResponse>(`/risks-requests/${requestId}`);
    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});

/* ---------- GET /api/v1/risks-requests/latest ---------- */
export const getLatestRisks = createAsyncThunk<RisksResponse, void, { rejectValue: ErrorResponse }>(
  'risks/latest',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get<RisksResponse>('/risks-requests/latest');
      return data;
    } catch (err) {
      const e = err as AxiosError<ErrorResponse>;
      return rejectWithValue({ message: e.response?.data?.message || e.message, status: e.response?.status });
    }
  },
);
